import React from 'react';
import { CardElementProps } from './types';

export default function CardFooter({ className = 'pt-3', ...props }: CardElementProps): JSX.Element {
	return <div className={className} {...props} />;
}
